import axios from 'axios';
import AnneescolaireService from './AnneescolaireService';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const COMPETENCE_URL = `${backendUrl}/api/competence/`;

class CompetenceService {
	async getAllCompetences(salledeclasseId = null, anneeScolaireId = null) {
		try {
			// Si anneeScolaireId n'est pas fourni, obtenir l'année scolaire courante
			if (anneeScolaireId === null) {
				const schoolYear = await AnneescolaireService.getCurrentAnneescolaire();
				anneeScolaireId = schoolYear.data.id;
			}

			// Construire les paramètres de requête
			const params = new URLSearchParams();
			if (salledeclasseId !== null)
				params.append('salledeclasseId', salledeclasseId);
			if (anneeScolaireId !== null)
				params.append('anneeScolaireId', anneeScolaireId);

			// Envoyer la requête au backend avec les paramètres
			const response = await axios.get(COMPETENCE_URL + 'filter/', { params });

			// Retourner les compétences filtrées directement depuis le backend
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getCompetence(id) {
		return axios.get(`${COMPETENCE_URL}${id}/`);
	}

	createCompetence(data) {
		return axios.post(COMPETENCE_URL, data).catch((error) => {
			console.error('Erreur lors de la création du competence', error);
			throw error;
		});
	}

	updateCompetence(id, data) {
		return axios.put(`${COMPETENCE_URL}${id}/`, data);
	}

	deleteCompetence(id) {
		return axios.delete(`${COMPETENCE_URL}${id}/`);
	}

	getCompetenceOptions(classId) {
		return this.getAllCompetences(classId).then((competences) => {
			// Convertir classId en entier
			const classIdInt = parseInt(classId, 10);

			// Si classId est fourni et est un nombre valide, filtrez les compétences pour ne conserver que celles qui contiennent classId dans leur champ classes.
			const filteredCompetences = !isNaN(classIdInt)
				? competences.filter((competence) =>
						competence.classes.includes(classIdInt)
				  )
				: competences;

			return filteredCompetences.map((competence) => ({
				value: competence.id,
				label: competence.nom.toUpperCase(),
				points_ecrit: competence.points_ecrit,
				points_oral: competence.points_oral,
				points_pratique: competence.points_pratique,
				points_savoir_etre: competence.points_savoir_etre
			}));
		});
	}
}

export default new CompetenceService();
